export type WIState = string[];

export const initialState: WIState = [] as WIState;
